var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    // #region ScheduleResourceDetailDayBase - Ctor
    ns.ScheduleResourceDetailDayBase = function ScheduleResourceDetailDayBase() {

    }
    // #endregion

    // #region ScheduleResourceDetailDayBase - Inheritance

    ns.ScheduleResourceDetailDayBase.prototype = new ns.ScheduleDayBase();
    ns.ScheduleResourceDetailDayBase.prototype.constructor = ns.ScheduleResourceDetailDayBase;
    ns.ScheduleResourceDetailDayBase.prototype.parent = ns.ScheduleDayBase.prototype;

    // #endregion

    // #region ScheduleResourceDetailDayBase - Methods
    ns.ScheduleResourceDetailDayBase.prototype.initialize = function (reservations, schedules, dayOfWeek, dayName, resourceID, activityID) {
        this.reservations = reservations;
        this.schedules = schedules;
        this.dayOfWeek = dayOfWeek;
        this.day = dayName;
        this.resourceID = resourceID;
        this.activityID = activityID;

        this.onDataSourceChange();
    }

    ns.ScheduleResourceDetailDayBase.prototype.getTimeValue = function (daySchedules, dayReservations, propertyName, min) {
        if (!daySchedules || !daySchedules.length || !dayReservations || !dayReservations.length) {
            return null;
        }

        var relevantReservations = this.getRelevantReservations(daySchedules, dayReservations);
        if (min) {
            return this.getMinTimeValue(relevantReservations, propertyName, true);
        } else {
            return this.getMaxTimeValue(relevantReservations, propertyName, true);
        }

        return null;
    }

    ns.ScheduleResourceDetailDayBase.prototype.getRelevantReservations = function (daySchedules, dayReservations) {
        if (!daySchedules || !daySchedules.length || !dayReservations || !dayReservations.length) {
            return [];
        }

        var ret = [];

        for (var s = 0; s < daySchedules.length; s++) {
            var activityScheduleID = daySchedules[s].activityScheduleID;
            for (var r = 0; r < dayReservations.length; r++) {
                var reservation = dayReservations[r];
                if (reservation.activityScheduleID === activityScheduleID) {
                    ret.push(reservation);
                }
            }
        }

        return ret;
    }

    ns.ScheduleResourceDetailDayBase.prototype.getReservationsByDay = function (sch, dayOfWeek) {
        var all = [];

        if (sch) {
            for (var s = 0; s < sch.length; s++) {
                var schedule = sch[s];
                var dateIndicia = schedule.firstPeriodStartDate ||
                                  schedule.firstPeriodEndDate ||
                                  schedule.secondPeriodStartDate ||
                                  schedule.secondPeriodEndDate;

                if (!!dateIndicia) {
                    var scheduleDayOfWeek = moment(dateIndicia).isoWeekday();

                    if (scheduleDayOfWeek === dayOfWeek) {
                        all.push(schedule);
                    }
                }
            }
        }

        return all;
    }

    ns.ScheduleResourceDetailDayBase.prototype.notScheduledProperty = function (daySchedules, propertyName) {
        if (!daySchedules || !daySchedules.length) {
            return true;
        }

        for (var d = 0; d < daySchedules.length; d++) {
            var schedule = daySchedules[d];
            if (schedule[propertyName]) {
                return false;
            }
        }

        return true;
    }

    ns.ScheduleResourceDetailDayBase.prototype.getRelevantReservations = function (daySchedules, dayReservations) {
        if (!daySchedules || !daySchedules.length || !dayReservations || !dayReservations.length) {
            return [];
        }

        var ret = [];

        for (var s = 0; s < daySchedules.length; s++) {
            var activityScheduleID = daySchedules[s].activityScheduleID;
            for (var r = 0; r < dayReservations.length; r++) {
                var reservation = dayReservations[r];
                if (reservation.activityScheduleID === activityScheduleID) {
                    ret.push(reservation);
                }
            }
        }

        return ret;
    }

    ns.ScheduleResourceDetailDayBase.prototype.getReservationByScheduleID = function (reservations, activityScheduleID) {
        if (!reservations || !reservations.length) {
            return null;
        }

        for (var r = 0; r < reservations.length; r++) {
            var res = reservations[r];
            if (res.activityScheduleID === activityScheduleID) {
                return res;
            }
        }

        return null;
    }

    ns.ScheduleResourceDetailDayBase.prototype.normalizeTimeValue = function (scheduleValue, value, min) {
        var normalizedValue = null;

        if (value) {
            var scheduleDate = moment(scheduleValue);
            var valueDate = moment(value);
            var scheduleMinutes = scheduleDate.hour() * 60 + scheduleDate.minute();
            var valueMinutes = valueDate.hour() * 60 + valueDate.minute();

            if (min) {
                if (scheduleMinutes <= valueMinutes) {
                    normalizedValue = new Date(scheduleDate.year(), scheduleDate.month(), scheduleDate.date(), valueDate.hour(), valueDate.minute(), 0 , 0);
                } else {
                    normalizedValue = scheduleValue;
                }
            } else {
                if (scheduleMinutes <= valueMinutes) {
                    normalizedValue = scheduleValue;
                } else {
                    normalizedValue = new Date(scheduleDate.year(), scheduleDate.month(), scheduleDate.date(), valueDate.hour(), valueDate.minute(), 0, 0);
                }
            }
        }

        return normalizedValue;
    }

    ns.ScheduleResourceDetailDayBase.prototype.isTimeIndeterminate = function (daySchedules, dayReservations, propertyName) {

        if (!daySchedules ||
            !daySchedules.length) {
            return false;
        }

        var first = true;
        var val = null;
        var rDate = null;
        var rMin = null;

        for (var s = 0; s < daySchedules.length; s++) {
            var schedule = daySchedules[s];
            if (schedule[propertyName]) {
                    
                var res = this.getReservationByScheduleID(dayReservations, schedule.activityScheduleID);
                if (!res) {
                    if (!first && val) {
                        return true;
                    }
                    first = false;
                } else {
                    var rvalue = res[propertyName];
                    if (first) {
                        if (rvalue) {
                            rDate = moment(rvalue);
                            rMin = rDate.hours() * 60 + rDate.minutes();
                            val = rMin;
                        }
                        first = false;
                    } else {
                        if (rvalue) {
                            rDate = moment(rvalue);
                            rMin = rDate.hours() * 60 + rDate.minutes();
                            if (val !== rMin) {
                                return true;
                            }
                        } else {
                            if (val === null) {
                                return true;
                            }
                        }
                    }
                }
            }
        }

        return false;
    }

    ns.ScheduleResourceDetailDayBase.prototype.getBoolValue = function (daySchedules, dayReservations, propertyName) {
        if (!daySchedules || !daySchedules.length || !dayReservations || !dayReservations.length) {
            return null;
        }

        var relevantReservations = this.getRelevantReservations(daySchedules, dayReservations);

        for (var d = 0; d < relevantReservations.length; d++) {
            var prop = relevantReservations[d][propertyName];
            if (prop) {
                return true;
            }
        }

        return false;
    }

    ns.ScheduleResourceDetailDayBase.prototype.getStringValue = function (daySchedules, dayReservations, propertyName) {
        if (!daySchedules || !daySchedules.length || !dayReservations || !dayReservations.length) {
            return null;
        }

        var relevantReservations = this.getRelevantReservations(daySchedules, dayReservations);

        var val = null;
        var first = true;

        for (var d = 0; d < relevantReservations.length; d++) {
            var prop = relevantReservations[d][propertyName];
            if (first) {
                first = false;
                val = prop;
            } else {
                if (val !== prop) {
                    return null;
                }
            }
        }

        return val;
    }

    ns.ScheduleResourceDetailDayBase.prototype.isBoolIndeterminate = function (daySchedules, dayReservations, propertyName) {
        if (!daySchedules ||
            !daySchedules.length) {
            return false;
        }

        var first = true;
        var val = null;

        for (var s = 0; s < daySchedules.length; s++) {
            var schedule = daySchedules[s];
            if (schedule[propertyName]) {

                var res = this.getReservationByScheduleID(dayReservations, schedule.activityScheduleID);
                if (!res) {
                    if (!first && val) {
                        return true;
                    }
                    first = false;
                } else {
                    var rvalue = res[propertyName];
                    if (first) {
                        val = rvalue;
                        first = false;
                    } else {
                        if (rvalue !== val) {
                            return true;
                        }
                    }
                }

            }
        }
    }

    ns.ScheduleResourceDetailDayBase.prototype.isStringIndeterminate = function (daySchedules, dayReservations, propertyName) {
        if (!daySchedules ||
            !daySchedules.length) {
            return false;
        }

        var first = true;
        var val = null;

        for (var s = 0; s < daySchedules.length; s++) {
            var schedule = daySchedules[s];

            var res = this.getReservationByScheduleID(dayReservations, schedule.activityScheduleID);
            if (!res) {
                if (!first && val) {
                    return true;
                }
                first = false;
            } else {
                var rvalue = res[propertyName];
                if (first) {
                    val = rvalue;
                    first = false;
                } else {
                    if (!String.prototype.isNullOrWhitespace(rvalue) && !String.prototype.isNullOrWhitespace(val) && (rvalue !== val)) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    ns.ScheduleResourceDetailDayBase.prototype.getAMNotScheduled = function (daySchedules) {
        if (!daySchedules || !daySchedules.length) {
            return true;
        }

        for (var s = 0; s < daySchedules.length; s++) {
            var daySchedule = daySchedules[s];
                
            if (!daySchedule['firstPeriodStartDate'] || 
                !daySchedule['firstPeriodEndDate']) {
                return true;
            }
        }

        return false;
    }

    ns.ScheduleResourceDetailDayBase.prototype.getPMNotScheduled = function (daySchedules) {
        if (!daySchedules || !daySchedules.length) {
            return true;
        }

        for (var s = 0; s < daySchedules.length; s++) {
            var daySchedule = daySchedules[s];

            if (!daySchedule['secondPeriodStartDate'] ||
                !daySchedule['secondPeriodEndDate']) {
                return true;
            }
        }

        return false;
    }

    ns.ScheduleResourceDetailDayBase.prototype.onDataSourceChange = function () {
        this.calculateProperties(this.schedules, this.reservations, this.dayOfWeek);
    }

    ns.ScheduleResourceDetailDayBase.prototype.createReservation = function (activityScheduleID) {
        return null;
    }

    ns.ScheduleResourceDetailDayBase.prototype.applyChangesToTimeProperty = function (daySchedules, reservations, propertyName, value, min) {

        for (var s = 0; s < daySchedules.length; s++) {
            var daySchedule = daySchedules[s];
            var scheduleValue = daySchedule[propertyName];
            if (!scheduleValue) {
                continue;
            }

            var normalizedValue = this.normalizeTimeValue(scheduleValue, value, min);

            var reservation = this.getReservationByScheduleID(reservations, daySchedule.activityScheduleID);
            if (!reservation) {
                if (normalizedValue) {
                        
                    reservation = this.createReservation(daySchedule.activityScheduleID);
                    reservation[propertyName] = normalizedValue;
                    reservations.push(reservation);
                }
            } else {
                reservation[propertyName] = normalizedValue;
            }
        }
    }

    ns.ScheduleResourceDetailDayBase.prototype.applyChangesToBoolProperty = function (daySchedules, reservations, propertyName, value) {
        for (var s = 0; s < daySchedules.length; s++) {
            var daySchedule = daySchedules[s];
            var scheduleValue = daySchedule[propertyName];

            var reservation = this.getReservationByScheduleID(reservations, daySchedule.activityScheduleID);
            if (reservation) {
                reservation[propertyName] = value && scheduleValue;
            } 
        }
    }

    ns.ScheduleResourceDetailDayBase.prototype.applyChangesToStringProperty = function (daySchedules, reservations, propertyName, value) {
        for (var s = 0; s < daySchedules.length; s++) {
            var daySchedule = daySchedules[s];
            var reservation = this.getReservationByScheduleID(reservations, daySchedule.activityScheduleID);
            if (reservation) {
                reservation[propertyName] = value;
            }
        }
    }

    ns.ScheduleResourceDetailDayBase.prototype.getReservationIndexByScheduleID = function (reservations, activityScheduleID) {
        for (var i = 0; i < reservations.length; i++) {
            var reservation = reservations[i];
            if (reservation.activityScheduleID === activityScheduleID) {
                return i;
            }
        }

        return -1;
    }

    ns.ScheduleResourceDetailDayBase.prototype.applyChanges = function () {

        var hasFirstPeriod = (!!this.firstPeriodStartDate && !!this.firstPeriodEndDate);
        var hasSecondPeriod = (!!this.secondPeriodStartDate && !!this.secondPeriodEndDate);
                           

        if (!(hasFirstPeriod || hasSecondPeriod)) {

            for (var s = 0; s < this.daySchedules.length; s++) {
                var schedule = this.daySchedules[s];
                var rindex = this.getReservationIndexByScheduleID(this.reservations, schedule.activityScheduleID);
                if (rindex !== -1) {
                    this.reservations.splice(rindex, 1);
                }
            }

            this.firstPeriodStartDateChanged = false;
            this.firstPeriodEndDateChanged = false;
            this.secondPeriodStartDateChanged = false;
            this.secondPeriodEndDateChanged = false;
            this.notesChanged = false;
        } else {
            if (hasFirstPeriod) {
                if (this.firstPeriodStartDateChanged) {
                    this.applyChangesToTimeProperty(this.daySchedules, this.reservations, 'firstPeriodStartDate', this.firstPeriodStartDate, true);
                    this.firstPeriodStartDateChanged = false;
                }
                if (this.firstPeriodEndDateChanged) {
                    this.applyChangesToTimeProperty(this.daySchedules, this.reservations, 'firstPeriodEndDate', this.firstPeriodEndDate, false);
                    this.firstPeriodEndDateChanged = false;
                }
            } else {
                if (this.firstPeriodStartDateChanged || this.firstPeriodEndDateChanged) {
                    this.applyChangesToTimeProperty(this.daySchedules, this.reservations, 'firstPeriodStartDate', null, true);
                    this.applyChangesToTimeProperty(this.daySchedules, this.reservations, 'firstPeriodEndDate', null, false);
                    this.firstPeriodStartDateChanged = false;
                    this.firstPeriodEndDateChanged = false;
                }
            }

            if (hasSecondPeriod) {
                if (this.secondPeriodStartDateChanged) {
                    this.applyChangesToTimeProperty(this.daySchedules, this.reservations, 'secondPeriodStartDate', this.secondPeriodStartDate, true);
                    this.secondPeriodStartDateChanged = false;
                }
                if (this.secondPeriodEndDateChanged) {
                    this.applyChangesToTimeProperty(this.daySchedules, this.reservations, 'secondPeriodEndDate', this.secondPeriodEndDate, false);
                    this.secondPeriodEndDateChanged = false;
                }
            } else {
                if (this.secondPeriodStartDateChanged || this.secondPeriodEndDateChanged) {
                    this.applyChangesToTimeProperty(this.daySchedules, this.reservations, 'secondPeriodStartDate', null, true);
                    this.applyChangesToTimeProperty(this.daySchedules, this.reservations, 'secondPeriodEndDate', null, false);
                    this.secondPeriodStartDateChanged = false;
                    this.secondPeriodEndDateChanged = false;
                }

            }

            if (this.notesChanged) {
                this.applyChangesToStringProperty(this.daySchedules, this.reservations, 'notes', this.notes);
                this.notesChanged = false;
            }
        }
    }

    ns.ScheduleResourceDetailDayBase.prototype.calculateProperties = function (schedules, reservations, dayOfWeek) {

        this.daySchedules = this.getSchedulesByDay(schedules, dayOfWeek);
        this.dayReservations = this.getReservationsByDay(reservations, dayOfWeek);

        this._firstPeriodStartDate = this.getTimeValue(this.daySchedules, this.dayReservations, 'firstPeriodStartDate', true);
        this._firstPeriodEndDate = this.getTimeValue(this.daySchedules, this.dayReservations, 'firstPeriodEndDate', false);
        this._secondPeriodStartDate = this.getTimeValue(this.daySchedules, this.dayReservations, 'secondPeriodStartDate', true);
        this._secondPeriodEndDate = this.getTimeValue(this.daySchedules, this.dayReservations, 'secondPeriodEndDate', false);
        this._notes = this.getStringValue(this.daySchedules, this.dayReservations, 'notes');


        this.notScheduled = !(this.daySchedules && this.daySchedules.length);
        this.notScheduledAM = this.getAMNotScheduled(this.daySchedules);
        this.notScheduledPM = this.getPMNotScheduled(this.daySchedules);

        this.firstPeriodStartDateMin = this.getMinTimeValue(this.daySchedules, 'firstPeriodStartDate');
        this.firstPeriodEndDateMax = this.getMaxTimeValue(this.daySchedules, 'firstPeriodEndDate');
        this.secondPeriodStartDateMin = this.getMinTimeValue(this.daySchedules, 'secondPeriodStartDate');
        this.secondPeriodEndDateMax = this.getMaxTimeValue(this.daySchedules, 'secondPeriodEndDate');


        this.firstPeriodStartDateIndeterminate = this.isTimeIndeterminate(this.daySchedules, this.dayReservations, 'firstPeriodStartDate');
        this.firstPeriodEndDateIndeterminate = this.isTimeIndeterminate(this.daySchedules, this.dayReservations, 'firstPeriodEndDate');
        this.secondPeriodStartDateIndeterminate = this.isTimeIndeterminate(this.daySchedules, this.dayReservations, 'secondPeriodStartDate');
        this.secondPeriodEndDateIndeterminate = this.isTimeIndeterminate(this.daySchedules, this.dayReservations, 'secondPeriodEndDate');
        this.notesIndeterminate = this.isStringIndeterminate(this.daySchedules, this.dayReservations, 'notes');


        this.firstPeriodStartDateNotScheduled = this.notScheduledProperty(this.daySchedules, 'firstPeriodStartDate');
        this.firstPeriodEndDateNotScheduled = this.notScheduledProperty(this.daySchedules, 'firstPeriodEndDate');
        this.secondPeriodStartDateNotScheduled = this.notScheduledProperty(this.daySchedules, 'secondPeriodStartDate');
        this.secondPeriodEndDateNotScheduled = this.notScheduledProperty(this.daySchedules, 'secondPeriodEndDate');
    }

    ns.ScheduleResourceDetailDayBase.prototype.getActive = function () {
        if (this.notScheduled) {
            return false;
        }

        return (!!this.firstPeriodStartDate && !!this.firstPeriodEndDate) ||
               (!!this.secondPeriodStartDate && !!this.secondPeriodEndDate);
    }

    ns.ScheduleResourceDetailDayBase.prototype.setActive = function (value) {
        if (value) {
            if (!this.firstPeriodStartDateNotScheduled) {
                this.firstPeriodStartDate = this.firstPeriodStartDateMin;
                this.firstPeriodEndDate = this.firstPeriodEndDateMax;
            }
            if (!this.secondPeriodStartDateNotScheduled) {
                this.secondPeriodStartDate = this.secondPeriodStartDateMin;
                this.secondPeriodEndDate = this.secondPeriodEndDateMax;
            }
        } else {
            this.firstPeriodStartDate = null;
            this.firstPeriodEndDate = null;
            this.secondPeriodStartDate = null;
            this.secondPeriodEndDate = null;
            this.notes = null;
        }
    }

    ns.ScheduleResourceDetailDayBase.prototype.getAmActive = function () {
        if (this.notScheduled) {
            return false;
        }

        return (!!this.firstPeriodStartDate && !!this.firstPeriodEndDate);
    }

    ns.ScheduleResourceDetailDayBase.prototype.setAmActive = function (value) {
        if (value) {
            if (!this.firstPeriodStartDateNotScheduled) {
                this.firstPeriodStartDate = this.firstPeriodStartDateMin;
                this.firstPeriodEndDate = this.firstPeriodEndDateMax;
            }
        } else {
            this.firstPeriodStartDate = null;
            this.firstPeriodEndDate = null;
        }
    }

    ns.ScheduleResourceDetailDayBase.prototype.getPmActive = function () {
        if (this.notScheduled) {
            return false;
        }

        return (!!this.secondPeriodStartDate && !!this.secondPeriodEndDate);
    }

    ns.ScheduleResourceDetailDayBase.prototype.setPmActive = function (value) {
        if (value) {
            if (!this.secondPeriodStartDateNotScheduled) {
                this.secondPeriodStartDate = this.secondPeriodStartDateMin;
                this.secondPeriodEndDate = this.secondPeriodEndDateMax;
            }
        } else {
            this.secondPeriodStartDate = null;
            this.secondPeriodEndDate = null;
        }
    }

    // #endregion

    // #region ScheduleResourceDetailDayBase - Properties
    Object.defineProperty(ns.ScheduleResourceDetailDayBase.prototype, "active", {
        get: function () { return this.getActive(); },
        set: function (value) { this.setActive(value); },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ScheduleResourceDetailDayBase.prototype, "amActive", {
        get: function () { return this.getAmActive(); },
        set: function (value) { this.setAmActive(value); },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ScheduleResourceDetailDayBase.prototype, "pmActive", {
        get: function () { return this.getPmActive(); },
        set: function (value) { this.setPmActive(value); },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ScheduleResourceDetailDayBase.prototype, "firstPeriodStartDate", {
        get: function () {
            return this._firstPeriodStartDate;
        },
        set: function (value) {
            this._firstPeriodStartDate = value !== null ? moment(value).toDate() : null;
            this.firstPeriodStartDateChanged = true;
            if (value !== undefined) {
                this.firstPeriodStartDateIndeterminate = this.isTimeIndeterminate2(this.daySchedules, 'firstPeriodStartDate', value, true);
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ScheduleResourceDetailDayBase.prototype, "firstPeriodEndDate", {
        get: function () {
            return this._firstPeriodEndDate;
        },
        set: function (value) {
            this._firstPeriodEndDate = value !== null ? moment(value).toDate() : null;
            this.firstPeriodEndDateChanged = true;
            if (value !== undefined) {
                this.firstPeriodEndDateIndeterminate = this.isTimeIndeterminate2(this.daySchedules, 'firstPeriodEndDate', value, false);
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ScheduleResourceDetailDayBase.prototype, "secondPeriodStartDate", {
        get: function () {
            return this._secondPeriodStartDate;
        },
        set: function (value) {
            this._secondPeriodStartDate = value !== null ? moment(value).toDate() : null;
            this.secondPeriodStartDateChanged = true;
            if (value !== undefined) {
                this.secondPeriodStartDateIndeterminate = this.isTimeIndeterminate2(this.daySchedules, 'secondPeriodStartDate', value, true);
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ScheduleResourceDetailDayBase.prototype, "secondPeriodEndDate", {
        get: function () {
            return this._secondPeriodEndDate;
        },
        set: function (value) {
            this._secondPeriodEndDate = value !== null ? moment(value).toDate() : null;
            this.secondPeriodEndDateChanged = true;
            if (value !== undefined) {
                this.secondPeriodEndDateIndeterminate = this.isTimeIndeterminate2(this.daySchedules, 'secondPeriodEndDate', value, false);
            }
        },
        enumerable: true,
        configurable: true
    });


    Object.defineProperty(ns.ScheduleResourceDetailDayBase.prototype, "notes", {
        get: function () {
            return this._notes;
        },
        set: function (value) {
            this._notes = value;
            this.notesChanged = true;
            if (value !== undefined) {
                this.notesIndeterminate = false;
            }
        },
        enumerable: true,
        configurable: true
    });
    // #endregion

}(webooker_acivity_models));
